/**
 * @file コンポーネント：サイドメニュー スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { clipPathHidden } from "~/src/styles/mixins";

// スタイル
export const StyledSidemenu = styled.aside`
    position: fixed;
    top: 64px;
    left: -328px;
    width: 328px;
    height: calc(100vh - 64px);
    padding: 40px 16px;
    overflow-y: auto;
    background-color: #25292d;
    transition: left 0.15s;

    &.is-open {
        left: 0;
    }
`;

export const StyledSidemenuHeadline = styled.h2`
    ${clipPathHidden};
`;

export const StyledHeaderNavigationDepartment = styled.div`
    position: relative;

    &::after {
        position: absolute;
        top: 0;
        right: 0;
        z-index: -1;
        width: 32px;
        height: 32px;
        color: #202020;
        font-weight: bold;
        font-size: 16px;
        line-height: 32px;
        text-align: center;
        content: "\f078";
    }
`;

export const StyledForm = styled.form``;

export const StyledFormDepartment = styled.div`
    position: relative;

    &::after {
        position: absolute;
        top: 0;
        right: 4px;
        bottom: 0;
        z-index: -1;
        width: 24px;
        height: 24px;
        margin: auto 0;
        color: #808385;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        content: "\f0d7";
    }
`;

export const StyledFormDepartmentSelect = styled.select`
    width: 100%;
    padding: 16px 28px 16px 16px;
    border-color: #808385;
    border-radius: 4px;
    background-color: transparent;
    color: #e3e3e4;
    font-size: 16px;
`;

export const StyledFormDepartmentSelectOption = styled.option`
    color: #000000;
`;

export const StyledSidemenuLinkButton = styled.a`
    display: block;
    width: 100%;
    padding: 12px 0;
    text-align: left;
    font-size: 16px;
    color: #e3e3e4;
    background-color: transparent;
    border: none;
    cursor: pointer;
    transition: background-color 0.2s, color 0.2s;

    &.with-divider {
        border-top: 1px solid #3a3f44;
        margin-top: 16px;
        padding-top: 16px;
    }
`;
